module.exports = __webpack_public_path__ + "img/alert.8cf16a50.svg";